import { getRawClaim } from './getValueFromToken';
import { hasOnlyRMAccess } from './hasOnlyRMAccess';
import { isPilotCustomer } from './isPilotCustomer';

/**
 * Whether the Magazines (Referral Marketing) section is shown in the DMP. Uses
 * the `showMagazines` claim when the token carries it; otherwise falls back to
 * the legacy sidebar rule, `isPilotCustomer || hasOnlyRMAccess`.
 */
export const showMagazines = () => {
  const claim = getRawClaim('showMagazines');
  return typeof claim === 'boolean' ? claim : isPilotCustomer() || hasOnlyRMAccess();
};
